import { Navigate } from "react-router-dom";
import type { ReactElement } from "react";
import { useUser } from "../../hooks/useUser";

const GuestRoute = ({ children }: any): ReactElement => {
  const user = useUser();

  if (user) {
    // user is authenticated, redirect to app
    return <Navigate to="/app/news" replace />;
  }

  return children as ReactElement;
};

export default GuestRoute;
